module.exports = __webpack_public_path__ + "img/4runner.cd3324e1.png";